import React, { PureComponent } from 'react';

export const DocumentFocusContext = React.createContext();

export class DocumentFocusProvider extends PureComponent {
    state = {
        focused: document.hasFocus()
    }

    componentDidMount() {
        const handleBlur = () => {
            this.setState({
                focused: false
            });
        }
        const handleFocus = () => {
            this.setState({
                focused: true
            });
        }
        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);

        this.removeBlurListener = () => window.removeEventListener('blur', handleBlur);
        this.removeFocusListener = () => window.removeEventListener('focus', handleFocus);
    }

    componentWillUnmount() {
        this.removeBlurListener && this.removeBlurListener();
        this.removeFocusListener && this.removeFocusListener();
    }

    render() {
        return (
            <DocumentFocusContext.Provider
                value={{
                    focused: this.state.focused
                }}
            >
                { this.props.children }
            </DocumentFocusContext.Provider>
        );
    }
}
